import { BASE_URI } from '@/shared/config';

import { ImageSizeType } from '../config/types';

export const getDisplayAssetSrcByPatientID = (
  patientID: string,
  imageSize: ImageSizeType,
): string =>
  `${BASE_URI}/api/storage/download/patient_display_asset/${imageSize}/${patientID}`;
